/** Shared so the bell can observe the page's mark-all-read without a shared store. */
export const MARK_ALL_READ_CACHE_KEY = 'notificationCenterMarkAllRead'

export const UNREAD_RAIL_WIDTH = 4

export const UNREAD_TINT_OPACITY = 0.05

export const SEVERITY_BADGE_SIZE = 34

export const BELL_BADGE_SIZE = 30

/** Theme spacing units between the card's chevron, badge and text block. */
export const CARD_GAP = 1.5

export const CARD_BORDER_RADIUS = 2

/** Card padding and line spacing, matching the prototype card. */
export const CARD_PADDING_X = 2.5

export const CARD_PADDING_Y = 1.75

export const CARD_TEXT_SPACING = 0.5

/** Fixed label column in the detail panel's metadata rows. */
export const META_LABEL_WIDTH = 90

/**
 * Chip presentation switches. Flip these to drop icons or color from every
 * notification type chip at once; individual chips can still override via props.
 */
export const NOTIFICATION_CHIP_DEFAULTS = Object.freeze({
  showIcon: true,
  showColor: true,
})

export const CHIP_TINT_OPACITY = Object.freeze({
  border: 0.4,
  background: 0.08,
})

/** Matches the vertical rhythm the search row had as a page-level element. */
export const TOOLBAR_PADDING_Y = 1.5

export const DETAIL_PANEL_PADDING_X = 2.5

export const DETAIL_PANEL_PADDING_Y = 2

/**
 * Notification toasts render in their own container, so the look is a property of the class rather
 * than something every push restates — and they stack apart from the app's "saved" confirmations,
 * which is half of what makes them read as notifications.
 */
export const NOTIFICATION_TOAST_CONTAINER_ID = 'notification-center'

/** The bell's popover: an anchored panel listing several rows, so it can afford the room. */
export const NOTIFICATION_PANEL_WIDTH = '27rem'

/**
 * Narrower than the popover on purpose: a toast is a transient overlay over whatever the user is doing,
 * not a panel they opened. Still wider than toastify's 320px default, which crowds three lines against a
 * badge and a close button. Has to be set on the toast, which reads its width from
 * `--toastify-toast-width` — the container alone has no effect. Clamped against narrow viewports in use.
 */
export const NOTIFICATION_TOAST_WIDTH = '24rem'

/** Theme spacing units of scroll room keeping the last card clear of the Intercom launcher. */
export const GRID_BOTTOM_CLEARANCE = 11
